import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import HideVisually from 'js/components/HideVisually/HideVisually'
import Tooltip from 'js/components/Tooltip/Tooltip'
import ActionButton from 'js/files/components/ActionButton'

import CopyIcon from 'icons/link.svg'

const CopyLinkButton = ({
    entity,
}: {
    entity: {
        title: string
        url: string
    }
}) => {
    const { title, url } = entity

    const { t } = useTranslation()

    const refFileAddress = useRef<HTMLInputElement>()

    const [isCopied, setIsCopied] = useState(false)

    const copyFileAddress = () => {
        refFileAddress?.current?.select()
        document.execCommand('copy')
        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 3000)
    }

    return (
        <>
            <Tooltip
                visible={isCopied}
                content={t('entity-file.link-copied')}
                offset={[0, 0]}
            >
                <ActionButton
                    variant="secondary"
                    onClick={copyFileAddress}
                    tooltip={t('entity-file.copy-link')}
                    aria-label={t('entity-file.copy-link-to', {
                        title,
                    })}
                >
                    <CopyIcon />
                </ActionButton>
            </Tooltip>
            <HideVisually aria-hidden>
                <input
                    tabIndex={-1}
                    type="text"
                    ref={refFileAddress}
                    value={`${window.location.origin}${url}`}
                    readOnly
                />
            </HideVisually>
            {isCopied && (
                <HideVisually role="alert">
                    {t('entity-file.link-copied')}
                </HideVisually>
            )}
        </>
    )
}

export default CopyLinkButton
